<template>
  <form>
    <div class="field">
      <label class="label">{{ $t("human task") }}</label>
      <div class="control">
        <input
          type="text"
          class="input"
          v-model="meta.human_task"
          :placeholder="$t('name')"
        />
      </div>
    </div>
  </form>
</template>
<script>
import {
  put,
  error_message,
  get,
  post,
  error_alert,
  generate_error_message_text,
  get_currency_settings,
  format_currency,
  api_host,
} from "@/utils";

export default {
  name: "UserTask",
  props: {
    settings: Object,
    required: true,
  },
  data() {
    return {
      meta: {},
    };
  },
  methods: {
    get_data() {
      let v = this;
      return v.meta;
    },
  },
  mounted() {
    let v = this;
    if (v.settings) v.meta = { ...v.settings };
  },
  watch: {},
};
</script>
<style></style>
